








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { isAudioFile, isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/BaseIcon";

@Component({ name: "OptionPreviewThumbnail", components: { BaseIcon } })
export default class OptionPreviewThumbnail extends Vue {
  @Prop({ required: true })
  public readonly postFile!: PostFileData;

  public get icon() {
    if (isAudioFile(this.postFile)) return "sci-music-box";
    if (isImageFile(this.postFile)) return "sci-image";
    if (isVideoFile(this.postFile)) return "sci-video";
    return "sci-file";
  }

  public get src() {
    if (!this.postFile.url) return "";
    if (isVideoFile(this.postFile)) return MediaFilesController.getVideoThumbnail(this.postFile.url, "240p");
    if (isImageFile(this.postFile)) return MediaFilesController.getImageThumbnail(this.postFile.url, "240p");
    return "";
  }
}
